module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "backmatter-rw Acknowledgments-rw auto-rw page-open-left-rw",
    attrs: {
      "epub:type": "backmatter acknowledgments",
      "id": "acknowledgements"
    }
  }, [_c('h1', {
    staticClass: "acknowledgements-title"
  }, [_c('a', {
    attrs: {
      "id": "page-ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/toc#toc-acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once again, the Katie Mac Street Team has kicked serious booty! I’d like to shower blessings on everyone who participated, and who helped move the dragons toward total global domination! A huge thank you to the following Street Teamers:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Chantal Clem")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Mary McCormick")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Dawn Henry")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Veronica Godinez-Woltman")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Shawna Szabo")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Rebecca Taylor")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Stacey S. Lewis")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Barbara Bass")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Erin Havey")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Dawn Addleman")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Kayla Lindberg")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Julie Atagi")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Susanna Jolicoeur")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Theresa McFarland")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Dawn Addleman")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_c('a', {
    attrs: {
      "id": "page-x"
    }
  }), _vm._v("Mandy Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Katie Fortenbacher")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Misty Snell")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Amy Hallmark")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Kala Bartic")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Leona Merrow")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Stacia Ahlfeld")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("LaJean Rodewald")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Lisa Partridge")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Christine Brooks")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Tracy Goll")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Heather W. Mottel")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Nicole Harris")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Cheryl Ann Moore")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Lynne Smith-Kinniburgh")]), _vm._v(" "), _c('p', {
    staticClass: "ul-list"
  }, [_vm._v("Carrie Parker")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-744fedbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 69
// module chunks = 0